import React, { Component } from "react";

import {EVSCANNER}          from "actions/const";

import View                 from "./View.js";

export default class FormContainer extends Component {
  render () {
    let {
      EVScanner
    } = this.props;

    let {
      formType
    } = EVScanner;

    switch (formType.toUpperCase()) {
      case "VIEW":
        return <View {...this.props}/>;
      default:
        return "";
    }
  }

  componentWillUnmount () {
    let {
      actions
    } = this.props;

    actions.setValue(
      EVSCANNER,
      {
        selectedData: null,
        formType: "",
        formId: "",
        countType: "",

        isLoading: false,
        isExporting: false,
        tableData: [],
        totalCount: 0,
        limit: 10
      }
    );
  }
}



// WEBPACK FOOTER //
// ./components/EVScanner/FormContainer/index.js